import React, { Fragment, useMemo } from 'react';
import styled from 'styled-components/native';
import { Platform } from 'react-native';
import { P } from './Typography';
import Link from './Link';
import * as Linking from 'expo-linking';

const StyledView = styled.View`
  max-width: 272px;
`;

const StyledLink = styled(Link)`
  color: black;
  font-size: 16px;
  line-height: 18px;
`;

const LinkPreview: React.FC<{
  text: string;
  url: string;
}> = props => {
  const { text, url } = props;
  const link = text.slice(0, url.length);

  return (
    <StyledView>
      <StyledLink
        onPress={() => {
          // open link in default browser or a new tab for web
          if (Platform.OS === 'web') {
            window.open(url, '_blank');
          } else {
            Linking.openURL(url);
          }
        }}
      >
        {link}
      </StyledLink>
    </StyledView>
  );
};

const InlineTextLinks: React.FC<{ text: string }> = props => {
  // useMemo to prevent re-render unless text changes
  return useMemo(() => {
    let text = props.text;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const urls = text.match(urlRegex); // get all urls in text
    const results: (JSX.Element | string)[] = [];
    if (urls) {
      // parse out urls and wrap with the Link element
      for (const url of urls) {
        const index = text.indexOf(url);
        results.push(text.slice(0, index));
        text = text.slice(index);
        results.push(<LinkPreview text={text} url={url} />);
        text = text.slice(url.length);
      }
    }
    results.push(text); // push remaining text
    return (
      <Fragment>
        {results.map((partial, index) => {
          // if plain text
          if (typeof partial === 'string') {
            if (partial.length !== 0) {
              return (
                <P color='dark' selectable key={index}>
                  {partial}
                </P>
              );
            }
            return;
          }
          // if component
          return <Fragment key={index}>{partial}</Fragment>;
        })}
      </Fragment>
    );
  }, [props.text]);
};

export default InlineTextLinks;
